






























	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import storeFournisseur, {FournisseurFilter} from '@/stores/modules/fournisseur';

	import InputDateFilter from '@/components/Input/DateFilter.vue';

	@Component({
		components: {
			InputDateFilter,
		}
	})
	export default class CrudFournisseurFilterReduce extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeFournisseur) private page!: number;
		@Stored(() => storeFournisseur) private filters!: FournisseurFilter;

		@WatchObjectProperties('filters', FournisseurFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeFournisseur.dispatch('getC', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();
		}
		
	}
